import React, { Component, Fragment } from 'react';
import { Col, Card, CardBody, Row, Table, Button } from 'reactstrap';
import moment from 'moment';
import { Field, reduxForm } from 'redux-form';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import generatePDF from './GeneratePdf';
import history from '../../../history';
import ReactTableActionsDiagnostic from '../../ClinicHistory/ClinicHistoryView/components/Diagnostic/ReactTableActionsDiagnostic';
import DataReactTable from '../../ClinicHistory/ClinicHistoryView/components/Diagnostic/DataReactTable';
import DataReactTableInterview from './DataReactTableInterview';
import { TextField } from '@material-ui/core';
import AlertModal from '../../../shared/components/Modal';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import MenuItem from '@material-ui/core/MenuItem';
import { getPlanningMetod } from '../../Utils/SexualPlanningMethod';
import Tooltip from '@material-ui/core/Tooltip';
import SaveIcon from '@material-ui/icons/Save';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import BlockIcon from '@material-ui/icons/Block';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import EditFallingRisks from '../../../shared/components/EditFallingRisks';
import DigitalSignature from '../../DigitalSignature/DigitalSignature';
import SearchModalCIE10 from '../../SearchModals/CIE10/SearchModalCIE10';
import SignatureModalUser from '../../Users/SignatureModal/SignatureModalUser';
import ListRadipharmacyDosse from '../../Admissions/SearchAdmissions/components/ListRadipharmacyDosse';

class FormInterview extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            typeOfDocument: '',
            documentNumber: '',
            names: '',
            firstLastName: '',
            secondLastName: '',
            gender: '',
            bloodType: '',
            age: '',
            date: '',
            birthday: null,
            today: new Date(),
            day: new Date(),
            civilStatus: '',
            race: '',
            ethnicity: '',
            city: '',
            address: '',
            telephone1: '',
            telephone2: '',
            cellphone: '',
            email: '',
            regime: '',
            urlLogo: "",
            weight: '',
            height: '',
            masa: '',
            professional: {},
            admissions: [],
            serter: [],
            profile: [],
            observations: '',
            impresions: '',
            data: [],
            services: [],
            showPdf: false,
            exist: false,
            third: [],
            diagnostic: {
                alergia: '',
                asma: '',
                marcapaso: '',
                implante: '',
                protesis: '',
                clips: '',
                bomba: '',
                balas: '',
                operado: '',
                grapas: '',
                embarazo: '',
                puentes: '',
                objetos: '',
                creatinina: '',
                otros: '',
                otrosText: ''
            },
            dataDiagnostic: [],
            diagnosticCIE10: [],
            openModal: false,
            id_Professional: '',
            id_entrevista: '',
            disableInput: false,
            onUpdate: true,
            tecnologo: {},
            estadoModalDiagn: true,
            colorAlertModal: 'info',
            openAlertModal: false,
            messageAlerModal: '',
            closed: false,
            radioPharmacy: [],
            nameRadioPharmacy: '',
            observacionRF: '',
            dosis: '',
            idUnitMeasurement: 0,
            unitsMedicine: [],
            nameUnitMeasurement: '',
            menopause: null,
            menstruationPatientDate: null,
            planningMethod: null,
            pregnancyTest: null,
            womanInformationEdit: false,
            loadAddedDiagnostics: false,
            editFallingRisks: false,
            signaturePatient: null,
            modalSignaturePad: false,
            openModalSignatureDoctor: false,
            openModalSignatureTecnologo: false,
            errors: { diagnosticCIE10: '' },
            radioPharmacyList: []
        };
        this.tableCie10Ref = React.createRef(null);
    }

    componentDidMount() {

        console.log("dataPatient", this.props);

        this.verifyWomanInformation();
        this._isMounted = true;
        this.getDataInterview();
        //if (this.props.dataPatient.id_admision_cita_padre !== null && this.props.dataPatient.id_admision_cita_padre !== undefined ) {
        if (this.props.dataPatient.id_admision_cita_padre !== null && this.props.dataPatient.id_admision_cita_padre !== undefined ) {
            this.loadInterView(this.props.dataPatient.id_admision_cita_padre);
        } else {
            this.loadInterView(this.props.dataPatient.id_admision);
        }
        this.setState({ date: this.props.dataPatient.fecha });
        this.getFiles();
        this.getUser(this.props.dataPatient.id_tecnologo);
        this.loadRadioPharmacy();
        this.loadUnitsMeasurement();
        this.changeIdtoNameMedicine();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }



    handlerObservacionRF = (observations) => {
        this.setState({ observacionRF: observations });
    }

    handlerNameRadioPharmacy = (nameRPharmacy) => {
        this.setState({ nameRadioPharmacy: nameRPharmacy });
    }

    handlerDosis = (dosis) => {
        this.setState({ dosis: dosis });
    }

    handlerObservations = (observations) => {
        this.setState({ observations: observations });
    }

    handlerImpresions = (impresions) => {
        this.setState({ impresions: impresions });
    }

    handlerAlergias = (alergia) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, alergia: alergia } });
    }

    handlerAsma = (asma) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, asma: asma } });
    }

    handlerMarcaPaso = (marcapaso) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, marcapaso: marcapaso } });
    }

    handlerImplante = (implante) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, implante: implante } });
    }

    handlerProtesis = (protesis) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, protesis: protesis } });
    }

    handlerClips = (clips) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, clips: clips } });
    }

    handlerBomba = (bomba) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, bomba: bomba } });
    }

    handlerBalas = (balas) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, balas: balas } });
    }

    handlerOperado = (operado) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, operado: operado } });
    }

    handlerGrapas = (grapas) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, grapas: grapas } });
    }

    handlerEmbarazo = (embarazo) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, embarazo: embarazo } });
    }

    handlerPuentes = (puentes) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, puentes: puentes } });
    }

    handlerObjetos = (objetos) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, objetos: objetos } });
    }

    trunc = (x) => {
        var isNeg = x < 0
        var decimal = x % 1
        var entera = isNeg ? Math.ceil(x) : Math.floor(x)

        var decimalFormated = Math.floor(
            Math.abs(decimal) * Math.pow(10, 2)
        )

        var finalNum = entera +
            ((decimalFormated / Math.pow(10, 2)) * (isNeg ? -1 : 1))

        return finalNum
    }

    handlerCreatinina = (creatinina) => {

        let value = creatinina;

        if (value !== 0)
            this.setState({ diagnostic: { ...this.state.diagnostic, creatinina: value } });
        else
            this.setState({ diagnostic: { ...this.state.diagnostic, creatinina: '' } });
    }

    handlerOtros = (otros) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, otros: otros } });
    }

    handlerOtrosText = (otrosText) => {
        this.setState({ diagnostic: { ...this.state.diagnostic, otrosText: otrosText } });
    }

    handlerOpenModalPDF = (e) => {
        this.setState({ showPdf: e })
    }

    handlerIdMseaurement = (e) => {
        this.setState({ idUnitMeasurement: e })

    }

    handlerInfoFemMenstruacion = (menstruacion) => {
        this.setState({ menstruationPatientDate: menstruacion })
    }
    handlerInfoFemPlanificacion = (metodoPlanificacion) => {
        this.setState({ planningMethod: metodoPlanificacion })
    }
    handlerInfoFemEmbarazo = (pregnancy) => {
        this.setState({ pregnancyTest: pregnancy })
    }
    handlerInfoFemMenopausia = (menopause) => {
        this.setState({ menopause: menopause })
    }

    handlerEditFallingRisks = (event) => {
        this.setState({ editFallingRisks: event })
    }

    changeIdtoNameMedicine = (unitmed) => {
        let unitMeasure = this.state.unitsMedicine.find(unit => unit.codigo == unitmed);
        if (unitMeasure != null && unitMeasure != undefined) {
            this.setState({ nameUnitMeasurement: unitMeasure.nombre });
        }
        console.log("SEARCHEDUNIT", unitMeasure);
    }

    loadUnitsMeasurement = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'medicamento-stock/listar-unidad-medida', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json()
            }
            else {
                throw new Error("Error en el servidor");
            }
        }).then((data) => {
            if (this._isMounted) {
                this.setState({ unitsMedicine: data }, () => console.log(this.state.unitsMedicine));
            }
        }).catch((error) => {
            console.log(error)
        })
    }

    searchCIE = (name, code) => {

        var data = {
            codigo: code.toUpperCase(),
            nombre: name
        };

        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'cie10/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.existe) {
                        resolve(data.contenido);
                    } else {
                        resolve([]);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        });
    };

    getUser = async (id) => {

        console.log("0");
        if (id !== null) {

            const dataToSend = { id_usuario: id };

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'usuario/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataToSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {

                    console.log(data);
                    this.setState({ tecnologo: data.contenido[0] });

                }).catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    getTecnologo = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/consultar-tecnologo?id_admision=' + this.props.dataPatient.id_admision, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.hasOwnProperty('tecnologo')) {
                    this.setState({ tecnologo: data.tecnologo });
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    }

    addUserToInterview = async () => {

        const user = JSON.parse(sessionStorage.getItem('usuario'));

        const dataSend = { id_usuario: parseInt(user.id_usuario), id_admision: parseInt(this.props.dataPatient.id_admision) };

        console.log("2");

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'tecnologo/vincular-admision', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    getDataInterview = async () => {

        const dataSend = { id_historia: this.props.dataPatient.id_historia, id_admision: parseInt(this.props.dataPatient.id_admision) }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("registro clinico data", data);
                this.setDataClinicEvent(data);

            })
            .catch((error) => {
                this.setState({ colorAlertModal: 'danger', messageAlerModal: 'Ha ocurrido un error', openAlertModal: true });
                console.error('Error:', error);
            });
    }

    loadInterView = async (id_admision) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-entrevista/consultar?id_admision=' + id_admision, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                
                if (data.existe) {
                    console.log("INTERVIEWLOADEDIDADMISION", data.contenido)
                    this.setState({ exist: true, disableInput: data.contenido.cerrado, closed: data.contenido.cerrado });
                    this.setDataInterview(data.contenido);
                    this.setState({ diagnosticCIE10: data.contenido.cie10_diagnostico.cie10_diagnostico });
                    if (data.contenido.firma_digital !== null && data.contenido !== undefined) {
                        let firmEvaluate = data.contenido.firma_digital;
                        let evaluatenull = firmEvaluate.includes('/null/');
                        if (evaluatenull !== true) {
                            this.setState({ signaturePatient: data.contenido.firma_digital !== null ? `${process.env.REACT_APP_PUBLIC_URL}${data.contenido.firma_digital}${sessionStorage.getItem('token')}` : null }, () => console.log("WAH", this.state.signaturePatient))
                        }
                    }
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });

    }

    setDataInterview = (data) => {
        console.log("aqui estoy", data);
        
        let interview = {
            alergia: data.entrevista.alergia ? 'x' : '',
            asma: data.entrevista.asma ? 'x' : '',
            marcapaso: data.entrevista.marca_paso ? 'x' : '',
            implante: data.entrevista.implante ? 'x' : '',
            protesis: data.entrevista.protesis ? 'x' : '',
            clips: data.entrevista.clips ? 'x' : '',
            bomba: data.entrevista.bomba_infusion ? 'x' : '',
            balas: data.entrevista.balas ? 'x' : '',
            operado: data.entrevista.operado ? 'x' : '',
            grapas: data.entrevista.grapas ? 'x' : '',
            embarazo: data.entrevista.embarazo ? 'x' : '',
            puentes: data.entrevista.puentes_dentales ? 'x' : '',
            objetos: data.entrevista.objetos_metalicos ? 'x' : '',
            creatinina: data.entrevista.creatinina,
            otros: data.entrevista.otros_sintomas ? 'x' : '',
            otrosText: data.entrevista.otros_sintomas_text
        }

        this.setState({
            id_entrevista: data.id_entrevista,
            observations: data.observaciones,
            impresions: data.impresion_diagnostica,
            diagnostic: interview,
        });
    }

    setDataClinicEvent = (data) => {

        this.setState({
            typeOfDocument: this.props.dataPatient.tip_documento,
            documentNumber: this.props.dataPatient.num_documento,
            names: this.props.dataPatient.fullname,
            gender: data.contenido.pacientes.sexo,
            city: data.contenido.pacientes.direccion.ciudad,
            address: data.contenido.pacientes.direccion.direccion,
            telephone: data.contenido.pacientes.telefono1,
            cellphone: data.contenido.pacientes.celular,
            email: data.contenido.pacientes.correo,
            civilStatus: data.contenido.pacientes.e_civil,
            bloodType: data.contenido.pacientes.tipo_sangre,
            professional: data.contenido.profesional,
            id_Professional: data.contenido.id_profesional,
            services: this.props.dataPatient.servicios,
            weight: this.props.dataPatient.peso,
            height: this.props.dataPatient.talla,
            masa: (this.props.dataPatient.peso / (Math.pow((this.props.dataPatient.talla / 100), 2))).toFixed(2),
        });

        this.calculateAge(data.contenido.pacientes.fec_nacimiento);
        this.loadDataProfile();
        this.loadDataCita();
        this.loadRadioPharmacy();

    }

    calculateAge = (birthday) => {
        let fecha = moment(birthday, "YYYYMMDD").fromNow(true);
        let nacimiento = moment(birthday).format("YYYY-MM-DD");
        let hoy = new Date();
        this.setState({ age: fecha, birthday: nacimiento, today: moment(hoy).format('LLL'), day: moment(hoy).format('LL') });
    }

    loadDataProfile = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.length > 0) {
                    this.setState({
                        profile: data[0],
                        urlLogo: process.env.REACT_APP_PUBLIC_URL + "clinica/" + data[0].id_clinica + "/logo/" + sessionStorage.getItem('token')
                    })
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    getFiles = async () => {

        let dataSend = {
            id_historia: parseInt(this.props.dataPatient.id_historia),
            id_admision: 0
        };

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                //console.log(data.contenido); 
                this.createDatateble(data.contenido);

            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    createDatateble = (data) => {

        let filterData = [];

        for (let i = 0; i < data.length; i++) {

            if (data[i].archivos !== null) {

                for (let j = 0; j < data[i].archivos.archivos.length; j++) {

                    filterData.push(data[i].archivos.archivos[j]);
                }
            }
        }

        this.setData(filterData);
    }

    compareDates = (date1, date2) => {
        let dayInMillis = 24 * 3600000;

        let days1 = Math.floor(date1.getTime() / dayInMillis);
        let days2 = Math.floor(date2.getTime() / dayInMillis);

        if (days1 < days2)
            return true;
        else
            return false;
    }

    setData = (data) => {

        let filterData = [];

        for (let obj of data) {

            if (this.compareDates(new Date(obj.fecha), new Date(this.props.dataPatient.fecha))) {

                if (obj.clase === "8" || obj.clase === "12" || obj.clase === "13") {

                    filterData.push({
                        clase: obj.clase === "1" ? "CONSENTIMIENTO INFORMADO" :
                            obj.clase === "2" ? "ECOCARDIOGRAMA MODO M" :
                                obj.clase === "3" ? "ECOCARDIOGRAMA STRESS" :
                                    obj.clase === "4" ? "ELECTROCARDIOGRAMAS" :
                                        obj.clase === "5" ? "FORMULA MEDICA" :
                                            obj.clase === "6" ? "HISTORIA CLINICA" :
                                                obj.clase === "7" ? "HOLTER CARDIACO" :
                                                    obj.clase === "8" ? "IMAGENOLOGIA" :
                                                        obj.clase === "9" ? "LABORATORIO CLINICO" :
                                                            obj.clase === "10" ? "MONITOREO DE PRESION ARTERIAL" :
                                                                obj.clase === "11" ? "ORDEN MEDICA" :
                                                                obj.clase === "12" ? "GAMAGRAFIAS" : 
                                                                obj.clase === "13" ? "RESONANCIA NUCLERA MAGNETICA" : 
                                                                obj.clase === "14" ? "DOCUMENTO DE IDENTIDAD" :
                                                                obj.clase === "15" ? "AUTORIZACION" :
                                                                obj.clase === "16" ? "OTROS" :
                                                                "",
                        fecha: obj.fecha,
                        hora: obj.hora,
                        nombre: obj.fileName,
                        usuario: typeof obj.usuario !== 'undefined' ? obj.usuario : "",
                        descripcion: obj.descripcion,
                        ruta: obj.ruta
                    });

                }
            }

        }

        //console.log(filterData);
        this.setState({ data: filterData });

    }

    callPrintEvent = async () => {

        //id del servicio, del documento y del paciente, id del tercero, 
        const user = JSON.parse(sessionStorage.getItem('usuario'));

        if (!this.state.exist) {
            this.getUser(user.id_usuario).then(() => {

                if (!this.validateFormInterview()) {
                    const data = {
                        profile: this.state.profile,
                        documents: this.state.data,
                        user: user.nombre,
                        peso: this.state.weight,
                        talla: this.state.height,
                        professional: this.state.professional,
                        remitente: this.props.dataPatient.remitente,
                        services: this.state.services,
                        fullname: this.state.names + ' ' + this.state.firstLastName + ' ' + this.state.secondLastName,
                        documentNumber: this.state.documentNumber,
                        regime: this.state.regime,
                        address: this.state.address,
                        telephone: this.state.telephone,
                        city: this.state.city,
                        birthday: this.state.birthday,
                        age: this.state.age,
                        gender: this.state.gender,
                        date: this.state.date,
                        today: this.state.today,
                        impresions: this.state.impresions,
                        observations: this.state.observations,
                        diagnostic: this.state.diagnostic,
                        urlLogo: this.state.urlLogo,
                        third: this.state.third,
                        id_Professional: this.state.id_Professional,
                        profesional: this.state.professional,
                        tecnologo: this.state.tecnologo,
                        radioPharmacyApplied: this.state.radioPharmacy,
                        unitMeasureMedice: this.state.nameUnitMeasurement,
                        cellphone: this.state.cellphone,
                        typeOfDocument: this.state.typeOfDocument,
                        urlSiganturePatient: this.state.signaturePatient,
                        radioPharmacyList: this.state.radioPharmacyList,
                        id_admision: this.props.dataPatient.id_admision,
                        diagnosticCIE10: this.state.diagnosticCIE10
                    };

                    this.setState({ exist: true }, console.log("PDFPrint", data));

                    generatePDF(data);

                    this.saveInterview().then(() => {
                        this.addUserToInterview();
                    });
                }
            });
        } else {
            this.getTecnologo().then(() => {
                const data = {
                    profile: this.state.profile,
                    documents: this.state.data,
                    user: user.nombre,
                    peso: this.state.weight,
                    talla: this.state.height,
                    professional: this.state.professional,
                    remitente: this.props.dataPatient.remitente,
                    services: this.state.services,
                    fullname: this.state.names + ' ' + this.state.firstLastName + ' ' + this.state.secondLastName,
                    documentNumber: this.state.documentNumber,
                    regime: this.state.regime,
                    address: this.state.address,
                    telephone: this.state.telephone,
                    city: this.state.city,
                    birthday: this.state.birthday,
                    age: this.state.age,
                    gender: this.state.gender,
                    date: this.state.date,
                    today: this.state.today,
                    impresions: this.state.impresions,
                    observations: this.state.observations,
                    diagnostic: this.state.diagnostic,
                    urlLogo: this.state.urlLogo,
                    third: this.state.third,
                    id_Professional: this.state.id_Professional,
                    profesional: this.state.professional,
                    tecnologo: this.state.tecnologo,
                    radioPharmacyApplied: this.state.radioPharmacy,
                    unitMeasureMedice: this.state.nameUnitMeasurement,
                    cellphone: this.state.cellphone,
                    typeOfDocument: this.state.typeOfDocument,
                    urlSiganturePatient: this.state.signaturePatient,
                    radioPharmacyList: this.state.radioPharmacyList,
                    id_admision: this.props.dataPatient.id_admision,
                    diagnosticCIE10: this.state.diagnosticCIE10
                };

                generatePDF(data);
            })


        }

    }

    loadDataCita = async () => {

        var data = { id_cita: this.props.dataPatient.id_cita };
        //id_agenda: this.props.dataEvent.id_agenda

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/consultarpaciente', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.setState({ regime: data.contenido.regimen });

                this.getThird(data.contenido.idCliente);

            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    getThird = async (id) => {

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/ver/' + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },

        }).then(response => {
            return response.json();
        })
            .then(data => {
                console.log(data);
                this.setState({ third: data.contenido[0] })

            }).catch((error) => {
                console.error('Error:', error);
            });
    }

    saveInterview = async () => {

        const dataSend = {
            id_admision: parseInt(this.props.dataPatient.id_admision),
            impresion_diagnostica: this.state.impresions,
            observaciones: this.state.observations,
            entrevista: {
                alergias: this.state.diagnostic.alergia === 'x' ? true : false,
                asma: this.state.diagnostic.asma === 'x' ? true : false,
                marca_paso: this.state.diagnostic.marcapaso === 'x' ? true : false,
                implante: this.state.diagnostic.implante === 'x' ? true : false,
                protesis: this.state.diagnostic.protesis === 'x' ? true : false,
                clips: this.state.diagnostic.clips === 'x' ? true : false,
                bomba_infusion: this.state.diagnostic.bomba === 'x' ? true : false,
                balas: this.state.diagnostic.balas === 'x' ? true : false,
                operado: this.state.diagnostic.operado === 'x' ? true : false,
                grapas: this.state.diagnostic.grapas === 'x' ? true : false,
                embarazo: this.state.diagnostic.embarazo === 'x' ? true : false,
                puentes_dentales: this.state.diagnostic.puentes === 'x' ? true : false,
                objetos_metalicos: this.state.diagnostic.objetos === 'x' ? true : false,
                creatinina: this.state.diagnostic.creatinina,
                otros_sintomas: this.state.diagnostic.otros === 'x' ? true : false,
                otros_sintomas_text: this.state.diagnostic.otrosText
            },
            cie10_diagnostico: this.state.diagnosticCIE10,
            firma_paciente: this.state.signaturePatient
        }

        console.log("1");
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-entrevista/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
                else {
                    throw new Error('Ha ocurrido un error en el servidor');
                }
            })
            .then(data => {
                this.setState({ colorAlertModal: 'success', messageAlerModal: 'Registro Clínico guardado correctamente', openAlertModal: true });
            })
            .catch((error) => {
                this.setState({ colorAlertModal: 'danger', messageAlerModal: 'Ha ocurrido un error', openAlertModal: true });
                console.error('Error:', error);
            });

    }

    updateInterview = async () => {
        const dataSend = {
            id_entrevista: parseInt(this.state.id_entrevista),
            id_admision: parseInt(this.props.dataPatient.id_admision),
            impresion_diagnostica: this.state.impresions,
            observaciones: this.state.observations,
            entrevista: {
                alergias: this.state.diagnostic.alergia === 'x' ? true : false,
                asma: this.state.diagnostic.asma === 'x' ? true : false,
                marca_paso: this.state.diagnostic.marcapaso === 'x' ? true : false,
                implante: this.state.diagnostic.implante === 'x' ? true : false,
                protesis: this.state.diagnostic.protesis === 'x' ? true : false,
                clips: this.state.diagnostic.clips === 'x' ? true : false,
                bomba_infusion: this.state.diagnostic.bomba === 'x' ? true : false,
                balas: this.state.diagnostic.balas === 'x' ? true : false,
                operado: this.state.diagnostic.operado === 'x' ? true : false,
                grapas: this.state.diagnostic.grapas === 'x' ? true : false,
                embarazo: this.state.diagnostic.embarazo === 'x' ? true : false,
                puentes_dentales: this.state.diagnostic.puentes === 'x' ? true : false,
                objetos_metalicos: this.state.diagnostic.objetos === 'x' ? true : false,
                creatinina: this.state.diagnostic.creatinina,
                otros_sintomas: this.state.diagnostic.otros === 'x' ? true : false,
                otros_sintomas_text: this.state.diagnostic.otrosText
            },
            cerrado: true,
            firma_paciente: this.state.signaturePatient
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-entrevista/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.text();
            })
            .then(data => {
                console.log(data);
                this.setState({ colorAlertModal: 'success', messageAlerModal: 'Registro Clínico Actualizado Correctamente', openAlertModal: true });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    validateOnOkModal = () => {
        switch (this.state.colorAlertModal) {
            case 'success':
                this.setState({ colorAlertModal: 'info', messageAlerModal: '', openAlertModal: false }, () => {
                    history.push({
                        //pathname: process.env.PUBLIC_URL + '/assitencial/admissions',
                        pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
                        state: { date: this.props.dataPatient.fecha }
                    });
                });
                break;
            case 'warning':
                this.updateInterview();
                break;
            case 'danger':
                this.setState({ colorAlertModal: 'info', messageAlerModal: '', openAlertModal: false });
                break;
        }
    }

    loadRadioPharmacy = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-radiofarmaco/listar-por-admision?id_admision=' + this.props.dataPatient.id_admision, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then((response) => {
            return response.json();
        }).then(response => {
            //Por ahora solo 1 farmaco
            if (response.length > 0 && this._isMounted) {
                let farmaco = response.find(rad => rad.id_admision == this.props.dataPatient.id_admision)
                this.setState({
                    radioPharmacyList: response,
                    radioPharmacy: farmaco,
                    idUnitMeasurement: farmaco.codigo_medida
                }, () => this.changeIdtoNameMedicine(farmaco.codigo_medida));
            }
            else {
                this.setState({ radioPharmacy: null, radioPharmacyList: [] });
            }
        }).catch((err) => {
            this.setState({ radioPharmacy: null, radioPharmacyList: [] });
        });
    }

    verifyWomanInformation = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar-informacion-femenina?id_historia=' + this.props.dataPatient.id_historia, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Server Error");
            }
        }).then(response => {
            let informacion_femenina = response.data;
            if (informacion_femenina != null) {
                this.setState({
                    menopause: informacion_femenina.informacion_femenina != null && informacion_femenina.informacion_femenina != undefined ? informacion_femenina.informacion_femenina.menopausia : null,
                    menstruationPatientDate: informacion_femenina.informacion_femenina != null && informacion_femenina.informacion_femenina != undefined ? informacion_femenina.informacion_femenina.menstruacion : null,
                    planningMethod: informacion_femenina.informacion_femenina != null && informacion_femenina.informacion_femenina != undefined ? informacion_femenina.informacion_femenina.planificacion : null,
                    pregnancyTest: informacion_femenina.informacion_femenina != null && informacion_femenina.informacion_femenina != undefined ? informacion_femenina.informacion_femenina.embarazo : null,
                }, () => {

                    console.log("pregnancyTest", this.state.pregnancyTest);
                    if (this.state.pregnancyTest == true) {
                        this.setState({ diagnostic: { ...this.state.diagnostic, embarazo: 'x' } });
                    }
                    else {
                        this.setState({ diagnostic: { ...this.state.diagnostic, embarazo: '' } });
                    }
                })
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    updateAdditionalPatientInformation = async () => {
        let informacion_femenina = null;
        if (this.state.gender.toUpperCase() == "FEMENINO") {
            informacion_femenina = {
                menopausia: this.state.menopause,
                menstruacion: this.state.menstruationPatientDate,
                planificacion: this.state.planningMethod,
                embarazo: this.state.pregnancyTest
            }
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/actualizar-informacion-femenina', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_historia: this.props.dataPatient.id_historia, informacion_femenina: informacion_femenina })
        }).then(response => {
            return response.json();
        }).then(data => {
            this.setState({ womanInformationEdit: false });
            this.verifyWomanInformation();
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    validateFormInterview = () => {
        var errors = this.state.errors;
        var error = false;

        if (this.state.diagnosticCIE10.length < 1) {
            errors.diagnosticCIE10 = "Seleccione al menos un diagnóstico";
            error = true;
        } else {
            errors.diagnosticCIE10 = "";
        }


        console.log("ERROSValidateForm", errors);
        this.setState({ errors: errors });
        return error;
    }

    render() {


        const reactTableDataInterview = {
            tableHeaderData: [{
                Header: 'CLASE DE DOCUMENTO',
                accessor: 'clase',
                //disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'FECHA',
                accessor: 'fecha',
            },
            {
                Header: 'DESCRIPCIÓN',
                accessor: 'descripcion',
            },
            {
                Header: 'NOMBRE',
                accessor: 'nombre',
            }
            ],
            tableRowsData: this.state.data
        };

        const reactTableFoundDiagnostics = {
            tableHeaderData: [{
                Header: 'Codigo',
                accessor: 'codigo',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'Nombre',
                accessor: 'nombre',
            },
            ],
            tableRowsData: this.state.dataDiagnostic
        };

        const regimesCharge = (regime_id) => {
            let regime_name = '';
            if (regime_id == 1) {
                regime_name = 'PARTICULAR'
            } else if (regime_id == 2) {
                regime_name = "SUBSIDIADO"
            } else if (regime_id == 3) {
                regime_name = "CONTRIBUTIVO"
            } else if (regime_id == 4) {
                regime_name = "REGIMEN ESPECIAL"
            } else if (regime_id == 5) {
                regime_name = "CONTRIBUTIVO COMPLEMENTARIO"
            } else if (regime_id == 6) {
                regime_name = "SOAT"
            }
            else if (regime_id == 7) {
                regime_name = "POLIZA"
            }
            else if (regime_id == 8)
            {
                regime_name = "PARTICULAR MEDICINA PREPAGADA";
            }
            else (regime_id == 9)
            {
                regime_name = "OTROS"
            }


            return regime_name;
        }

        const LoadInfo = () => {
            return (<DataReactTableInterview
                reactTableData={reactTableDataInterview} modalShowPDF={this.handlerOpenModalPDF} modalState={this.state.showPdf}
            />)
        }

        const RadiopharmacyListDosse = () => {
            return <ListRadipharmacyDosse reactTableData={this.state.radioPharmacyList} />
        }

        return (
            <Col>
                <Card>
                    <CardBody>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'initial', padding: '0em 0.25em' }}>
                            <div style={{ marginBottom: 20 }}>
                                <h4 >DATOS DEL PACIENTE</h4>
                            </div>
                        </div>
                        <Row >
                            <Col xs={12} md={4}>
                                <h5> <b> NOMBRE </b> {this.state.names}  {this.state.firstLastName} {this.state.secondLastName}</h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <h5> <b>  IDENTIFICACION </b> {this.state.typeOfDocument}-{this.state.documentNumber}</h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <h5 > <b>  ADMISIÓN No. </b> {this.props.dataPatient.id_admision}</h5>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 15 }} >
                            <Col xs={12} md={4}>
                                <h5 > <b>  REGIMEN </b> {this.state.regime !== null && this.state.regime !== undefined ? regimesCharge(this.state.regime) : ""}</h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <h5> <b> DIRECCIÓN </b> {this.state.address}  </h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <h5 > <b> TELÉFONO </b> {this.state.telephone}</h5>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 15 }} >
                            <Col xs={12} md={4}>
                                <h5 > <b> EPS </b> {this.state.third.nombre} </h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <h5> <b> MUNICIPIO </b> {this.state.city}  </h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <h5 > <b> FECHA DE NACIMIENTO </b> {this.state.birthday}</h5>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 15 }} >
                            <Col xs={12} md={4}>
                                <h5 > <b> EDAD </b>  {this.state.age.toUpperCase()} </h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <h5> <b> PESO </b> {this.state.weight}  kg - <b>  Talla </b> {this.state.height} cm</h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <h5> <b>INDICE DE MASA CORPORAL</b>  {isNaN(this.state.masa) ? ' ' : this.state.masa} </h5>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 15 }} >
                            <Col xs={12} md={4}>
                                <h5> <b> GENERO </b> {this.state.gender.toUpperCase()} </h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <h5> <b> FECHA INICIAL DE ATENCION </b> {this.state.date}  </h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <h5 > <b> MEDICO REMITE </b> {this.props.dataPatient.remitente !== null && this.props.dataPatient.remitente !== undefined ? this.props.dataPatient.remitente.toUpperCase() : ''} </h5>
                            </Col>
                        </Row>
                        {
                            this.state.gender.toUpperCase() == "FEMENINO" ?
                                <Fragment>
                                    <Row style={{ marginTop: 15 }} >
                                        <Col xs={12} md={3}>
                                            <h5> <b> TIENE MENOPAUSIA </b> {this.state.menopause == true ? "SI" : "NO"}  </h5>
                                        </Col>
                                        {
                                            this.state.menopause !== true ?
                                                <Fragment>
                                                    <Col xs={12} md={3}>
                                                        <h5 > <b> ULTIMA MENSTRUACIÓN </b> {this.state.menstruationPatientDate != null ? moment(this.state.menstruationPatientDate).format("DD/MM/YYYY") : null} </h5>
                                                    </Col>
                                                    <Col xs={12} md={3}>
                                                        <h5 > <b> METODO DE PLANIFICACIÓN </b> {getPlanningMetod(this.state.planningMethod)} </h5>
                                                    </Col>
                                                    <Col xs={12} md={3}>
                                                        <h5 > <b> ESTA EMBARAZADA. </b> {this.state.pregnancyTest == true ? "SI" : "NO"} </h5>
                                                    </Col>
                                                </Fragment>
                                                : null
                                        }
                                        <Col style={{ marginTop: 0 }}>
                                            {
                                                this.state.womanInformationEdit == false ?
                                                    <Tooltip title="Editar información paciente con genero femenino">
                                                        <IconButton aria-label="upload picture" component="span"
                                                            onClick={() => {
                                                                this.setState({ womanInformationEdit: true });
                                                            }}>
                                                            <EditOutlinedIcon />
                                                        </IconButton>
                                                    </Tooltip> : <>
                                                        <Tooltip title="Actualizar Datos">
                                                            <IconButton aria-label="upload picture" component="span"
                                                                onClick={() => {
                                                                    this.updateAdditionalPatientInformation();
                                                                }}>
                                                                <SaveIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Cancelar Edición">
                                                            <IconButton aria-label="upload picture" component="span"
                                                                onClick={() => {
                                                                    this.setState({ womanInformationEdit: false });
                                                                }}>
                                                                <BlockIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                            }
                                        </Col>
                                    </Row>
                                    {
                                        this.state.womanInformationEdit == true ?
                                            <Row>
                                                <Col md={3}>
                                                    <Row>
                                                        <Col>
                                                            <FormControl
                                                                //className={classes.date}
                                                                style={{ width: '100%' }}
                                                            //error={this.state.errors.hasOwnProperty("menopause") ? this.state.errors.gender !== "" : false}
                                                            >
                                                                <InputLabel required id="menopause-simple-select-label" shrink={true}>Menopausia</InputLabel>
                                                                <Select
                                                                    labelId="menopause-simple-select-label"
                                                                    id="menopause-simple-select"
                                                                    defaultValue={null}
                                                                    //disabled={this.state.disabled}
                                                                    value={this.state.menopause}
                                                                    onChange={(event) => {
                                                                        this.handlerInfoFemMenopausia(event.target.value);
                                                                    }}
                                                                //error={this.state.errors.hasOwnProperty("menopausia") ? this.state.errors.gender !== "" : false}
                                                                >
                                                                    <MenuItem key={0} value={true}>SI</MenuItem>
                                                                    <MenuItem key={1} value={false}>NO</MenuItem>
                                                                </Select>
                                                                {/* <FormHelperText>{this.state.errors.gender}</FormHelperText> */}
                                                            </FormControl>
                                                        </Col>
                                                        {
                                                            this.state.menopause !== null && this.state.menopause !== true ?
                                                                <Col>
                                                                    <FormControl
                                                                        //className={classes.date}
                                                                        style={{ width: '100%' }}
                                                                    //error={this.state.errors.hasOwnProperty("embarazo") ? this.state.errors.embarazo !== "" : false}
                                                                    >
                                                                        <InputLabel required id="embarazo-simple-select-label">Esta embarazada?</InputLabel>
                                                                        <Select
                                                                            labelId="embarazo-simple-select-label"
                                                                            id="embarazo-simple-select"
                                                                            defaultValue={null}
                                                                            disabled={this.state.disabled}
                                                                            value={this.state.pregnancyTest}
                                                                            onChange={(event) => {
                                                                                this.handlerInfoFemEmbarazo(event.target.value);
                                                                            }}
                                                                        //error={this.state.errors.hasOwnProperty("embarazo") ? this.state.errors.embarazo !== "" : false}
                                                                        >
                                                                            <MenuItem key={0} value={true}>SI</MenuItem>
                                                                            <MenuItem key={1} value={false}>NO</MenuItem>
                                                                        </Select>
                                                                        {/* <FormHelperText>{this.state.errors.embarazo}</FormHelperText> */}
                                                                    </FormControl>
                                                                </Col>
                                                                : null
                                                        }
                                                    </Row>
                                                </Col>
                                                {
                                                    this.state.menopause !== true && this.state.menopause !== null ?
                                                        <Fragment>
                                                            <Col md={3}>
                                                                <FormControl
                                                                    //className={classes.date}
                                                                    style={{ width: '100%' }}
                                                                //error={this.state.errors.hasOwnProperty("planificacion") ? this.state.errors.planificacion !== "" : false}
                                                                >
                                                                    <InputLabel required id="planificacion-simple-select-label">M. Planificación</InputLabel>
                                                                    <Select
                                                                        labelId="planificacion-simple-select-label"
                                                                        id="planificacion-simple-select"
                                                                        defaultValue={null}
                                                                        disabled={this.state.disabled}
                                                                        value={this.state.planningMethod}
                                                                        onChange={(event) => {
                                                                            this.handlerInfoFemPlanificacion(event.target.value);
                                                                        }}
                                                                    //error={this.state.errors.hasOwnProperty("planificacion") ? this.state.errors.planificacion !== "" : false}
                                                                    >
                                                                        <MenuItem value={1}>PÍLDORA ANTICONCEPTIVA</MenuItem>
                                                                        <MenuItem value={2}>SISTEMA INTRAUTERINO - SIU</MenuItem>
                                                                        <MenuItem value={3}>CONDÓN MASCULINO</MenuItem>
                                                                        <MenuItem value={4}>PARCHE ANTICONCEPTIVO</MenuItem>
                                                                        <MenuItem value={5}>ANILLO ANTICONCEPTIVO</MenuItem>
                                                                        <MenuItem value={6}>IMPLANTE ANTICONCEPTIVO</MenuItem>
                                                                        <MenuItem value={7}>INYECCIÓN ANTICONCEPTIVA</MenuItem>
                                                                        <MenuItem value={8}>DISPOSITIVO INTRAUTERINO - DIU</MenuItem>
                                                                        <MenuItem value={9}>CONDÓN FEMENINO</MenuItem>
                                                                        <MenuItem value={10}>DIAFRAGMA</MenuItem>
                                                                        <MenuItem value={11}>CAPUCHÓN CERVICAL</MenuItem>
                                                                        <MenuItem value={12}>ESPONJA</MenuItem>
                                                                        <MenuItem value={13}>ESPERMICIDA</MenuItem>
                                                                        <MenuItem value={14}>ESTERILIZACIÓN</MenuItem>
                                                                        <MenuItem value={15}>PASTILLA DE EMERGENCIA</MenuItem>
                                                                        <MenuItem value={16}>ABSTINENCIA SEXUAL</MenuItem>
                                                                        <MenuItem value={17}>NINGUNA</MenuItem>
                                                                    </Select>
                                                                    {/* <FormHelperText>{this.state.errors.planificacion}</FormHelperText> */}
                                                                </FormControl>
                                                            </Col>
                                                            <Col md={3}>
                                                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                                                    <DatePicker
                                                                        disableFuture
                                                                        style={{ width: '100%' }}
                                                                        openTo="year"
                                                                        label="Ultima Menstruación"
                                                                        views={["year", "month", "date"]}
                                                                        //disabled={this.state.disabled}
                                                                        value={this.state.menstruationPatientDate}
                                                                        onChange={(date) => {
                                                                            //this.handlerBirthDate(new Date(date));
                                                                            this.handlerInfoFemMenstruacion(new Date(date));
                                                                        }}
                                                                        animateYearScrolling
                                                                        format="yyyy/MM/D"
                                                                    //className={classes.date}
                                                                    //error={this.state.errors.hasOwnProperty("menstruacion") ? this.state.errors.menstruacion !== "" : false}
                                                                    //helperText={this.state.errors.menstruacion}
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                            </Col>
                                                            <Col md={3}>
                                                            </Col>

                                                        </Fragment>
                                                        : null
                                                }
                                            </Row>
                                            : null
                                    }
                                </Fragment>
                                : null
                        }


                        <Table responsive bordered style={{ width: '100%', marginTop: 40, }}>
                            <thead>
                                <tr>
                                    <td>CUPS </td>
                                    <td >PROCEDIMIENTO </td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.services.map((data, index) => {
                                    return <tr key={index}>
                                        <td>{data.codigo}</td>
                                        <td>{data.nombre}</td>
                                    </tr>
                                })}
                            </tbody>
                        </Table>


                        <h4 style={{ marginTop: 30 }}> APLICACIÓN DE MEDICAMENTOS </h4>
                        <RadiopharmacyListDosse />

                        {/*
                        <Row style={{ marginTop: 10 }}>
                            <Col>
                                <TextField
                                    required
                                    id="txtNombreMedicamento"
                                    label="Nombre Medicamento | Unidad"
                                    disabled={true}
                                    value={this.state.radioPharmacy != undefined && this.state.radioPharmacy != null ? this.state.radioPharmacy.nombre_medicamento : null}
                                    onChange={(e) => {
                                        this.handlerNameRadioPharmacy(e.target.value)
                                    }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        shrink: true,
                                        style: { color: '#646777' }
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%', marginTop: 5 }}
                                >
                                </TextField>
                            </Col>
                            <Col>
                                <TextField
                                    required
                                    id="txtCant"
                                    label="Dosis"
                                    disabled={true}
                                    value={this.state.radioPharmacy != undefined && this.state.radioPharmacy != null ? this.state.radioPharmacy.dosis : null}
                                    InputProps={{ inputProps: { min: 0, max: 100 } }}
                                    type="number"
                                    onChange={(e) => {
                                        this.handlerDosis(e.target.value)
                                    }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        shrink: true,
                                        style: { color: '#646777' }
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%', marginTop: 5 }}
                                >
                                </TextField>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <TextField
                                    required
                                    id="txtObservacion"
                                    label="Observación"
                                    disabled={true}
                                    value={this.state.radioPharmacy != undefined && this.state.radioPharmacy != null ? this.state.radioPharmacy.observacion : null}
                                    onChange={(e) => {
                                        this.handlerObservacionRF(e.target.value)
                                    }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        shrink: true,
                                        style: { color: '#646777' }
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%', marginTop: 5 }}
                                >
                                </TextField>
                            </Col>
                            <Col md={3}>
                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                    <KeyboardDateTimePicker
                                        value={this.state.radioPharmacy != undefined && this.state.radioPharmacy != null ? this.state.radioPharmacy.fecha_aplicacion : null}
                                        disabled={true}
                                        //onChange={(date) => setFechaAplicacion(date)}
                                        label="Fecha de Aplicación del Farmaco"
                                        format="yyyy-MM-DD"
                                        animateYearScrolling
                                        className='medical-material-form__field material-form__label'
                                        style={{ minWidth: '300px', maxWidth: '100%', marginTop: 5 }}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: { color: '#646777' }
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Col>
                            <Col md={3}>
                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                    <KeyboardDateTimePicker
                                        value={this.state.radioPharmacy != undefined && this.state.radioPharmacy != null ? this.state.radioPharmacy.fecha_aplicacion : null}
                                        disabled={true}
                                        //onChange={(date) => setFechaAplicacion(date)}
                                        label="Hora de Aplicación del Farmaco"
                                        format="HH:mm:ss"
                                        animateYearScrolling
                                        className='medical-material-form__field material-form__label'
                                        style={{ minWidth: '300px', maxWidth: '100%', marginTop: 5 }}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: { color: '#646777' }
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Col>
                            <Col md={3}>
                                {this.state.radioPharmacy == null ?
                                    <div style={{ marginTop: 25 }}>
                                        <span style={{ color: "#CDCCCB", marginTop: 15 }}> Hasta el momento no se ha realizado ninguna aplicación de medicamento.</span>

                                    </div>
                                    : null
                                }
                            </Col>
                        </Row>
                        */}


                        <hr></hr>



                        <h4 style={{ marginTop: 30 }}> IMPRESION DIAGNOSTICA </h4>

                        {
                            this.props.seeInputDiag !== false ?
                                <div className="form__form-group" style={{ marginTop: 20 }}>
                                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10 }} > Buscar Diagnostico</span>
                                    <Button
                                        outline
                                        style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                                        onClick={() => {

                                            this.setState({ openModal: !this.state.openModal });
                                        }}
                                    >
                                        <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                                    </Button>
                                </div>
                                : null
                        }

                        <Table bordered style={{ marginTop: 20 }}>
                            <thead>
                                <tr>
                                    <td>CODIGO </td>
                                    <td >DESCRIPCIÓN </td>
                                    <td >OPCIONES </td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.diagnosticCIE10.map((data, index) => {
                                    return <tr key={index}>
                                        <td>{data.codigo}</td>
                                        <td>{data.nombre}</td>
                                        <td>
                                            <Tooltip title="Quitar diagnostico">
                                                <IconButton aria-label="upload picture" component="span"
                                                    onClick={() => {
                                                        var diagnostics = this.state.diagnosticCIE10;
                                                        var dataNew = diagnostics.filter((value, indexDiag) => {
                                                            console.log("INDEXDIAG", indexDiag, "INDEXDIAGNOSTIC", index)
                                                            return indexDiag !== index;
                                                        })
                                                        console.log("OLDDIAGNOSTICS", diagnostics);
                                                        console.log("NEWDATA", dataNew);
                                                        this.setState({ diagnosticCIE10: dataNew });

                                                    }}>
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </td>
                                    </tr>
                                })}
                                <FormHelperText
                                    error={this.state.errors.hasOwnProperty("diagnosticCIE10") ? this.state.errors.diagnosticCIE10 !== "" : false}
                                    focused={this.state.errors.hasOwnProperty("diagnosticCIE10") ? this.state.errors.diagnosticCIE10 !== "" : false}
                                >{this.state.errors.diagnosticCIE10}</FormHelperText>
                            </tbody>

                        </Table>

                        <div className="form" style={{ flex: 1, flexDirection: 'column', marginTop: 20 }}>
                            <div className="form__form-group">
                                <div className="form__form-group-field">
                                    <textarea
                                        name="textarea-impresion-inteview"
                                        disabled={this.state.disableInput}
                                        //maxLength={200}
                                        defaultValue={this.state.impresions}
                                        onChange={(e) => { this.handlerImpresions(e.target.value.replace(/(\r\n|\n|\r)/gm, " ")) }}
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>

                        <h4> ESTUDIOS ANTERIORES </h4>
                        <br></br>
                        {
                            <LoadInfo />
                        }

                        <div className="form" style={{ flex: 1, flexDirection: 'column', marginBottom: 20, marginTop: 20 }}>
                            <div className="form__form-group">
                                <h4> Observaciones: </h4>
                                <div className="form__form-group-field">
                                    <textarea
                                        name="textarea-observation-inteview"
                                        disabled={this.state.disableInput}
                                        defaultValue={this.state.observations}
                                        onChange={(e) => { this.handlerObservations(e.target.value.replace(/(\r\n|\n|\r)/gm, " ")) }}
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>

                        <h4> ANTECEDENTES </h4>
                        <form className="material-form" >
                            <Row>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" disabled={this.state.disableInput}>
                                        <h5 className="bold-text">Alergias: </h5>
                                        <RadioGroup
                                            aria-label="alergias"
                                            name="alergias"
                                            className="material-form__field"
                                            style={{ flexDirection: 'row' }}
                                            value={this.state.diagnostic.alergia}
                                            onChange={e => {
                                                this.handlerAlergias(e.target.value);
                                            }}
                                        >
                                            <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                            <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" disabled={this.state.disableInput} >
                                        <h5 className="bold-text">Asma: </h5>
                                        <RadioGroup
                                            aria-label="asma"
                                            name="asma"
                                            className="material-form__field"
                                            style={{ flexDirection: 'row' }}
                                            value={this.state.diagnostic.asma}
                                            onChange={e => {
                                                this.handlerAsma(e.target.value);
                                            }}
                                        >
                                            <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                            <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" disabled={this.state.disableInput} >
                                        <h5 className="bold-text">Marcapaso: </h5>
                                        <RadioGroup
                                            aria-label="marcapaso"
                                            name="marcapaso"
                                            className="material-form__field"
                                            style={{ flexDirection: 'row' }}
                                            value={this.state.diagnostic.marcapaso}
                                            onChange={e => {
                                                this.handlerMarcaPaso(e.target.value);
                                            }}
                                        >
                                            <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                            <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" disabled={this.state.disableInput}>
                                        <h5 className="bold-text">Implante: </h5>
                                        <RadioGroup
                                            aria-label="implante"
                                            name="implante"
                                            className="material-form__field"
                                            style={{ flexDirection: 'row' }}
                                            value={this.state.diagnostic.implante}
                                            onChange={e => {
                                                this.handlerImplante(e.target.value);
                                            }}
                                        >
                                            <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                            <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" disabled={this.state.disableInput}  >
                                        <h5 className="bold-text">Protesis: </h5>
                                        <RadioGroup
                                            aria-label="protesis"
                                            name="protesis"
                                            className="material-form__field"
                                            style={{ flexDirection: 'row' }}
                                            value={this.state.diagnostic.protesis}
                                            onChange={e => {
                                                this.handlerProtesis(e.target.value);
                                            }}
                                        >
                                            <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                            <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" disabled={this.state.disableInput}>
                                        <h5 className="bold-text">Bomba Infusión: </h5>
                                        <RadioGroup
                                            aria-label="bomba"
                                            name="bomba"
                                            className="material-form__field"
                                            style={{ flexDirection: 'row' }}
                                            value={this.state.diagnostic.bomba}
                                            onChange={e => {
                                                this.handlerBomba(e.target.value);
                                            }}
                                        >
                                            <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                            <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" disabled={this.state.disableInput} >
                                        <h5 className="bold-text">Embarazo: </h5>
                                        <RadioGroup
                                            aria-label="embarazo"
                                            name="embarazo"
                                            className="material-form__field"
                                            style={{ flexDirection: 'row' }}
                                            value={this.state.diagnostic.embarazo}
                                            onChange={e => {
                                                this.handlerEmbarazo(e.target.value);
                                            }}
                                        >
                                            <FormControlLabel className="radio-btn" disabled={this.state.gender === 'Masculino' || this.state.gender === 'Binario'} value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                            <FormControlLabel className="radio-btn" disabled={this.state.gender === 'Masculino' || this.state.gender === 'Binario'} value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" disabled={this.state.disableInput} >
                                        <h5 className="bold-text">Puentes Dentales: </h5>
                                        <RadioGroup
                                            aria-label="puentes"
                                            name="puentes"
                                            className="material-form__field"
                                            style={{ flexDirection: 'row' }}
                                            value={this.state.diagnostic.puentes}
                                            onChange={e => {
                                                this.handlerPuentes(e.target.value);
                                            }}
                                        >
                                            <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                            <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" disabled={this.state.disableInput} >
                                        <h5 className="bold-text">Objetos Metalicos: </h5>
                                        <RadioGroup
                                            aria-label="metalicos"
                                            name="metalicos"
                                            className="material-form__field"
                                            style={{ flexDirection: 'row' }}
                                            value={this.state.diagnostic.objetos}
                                            onChange={e => {
                                                this.handlerObjetos(e.target.value);
                                            }}
                                        >
                                            <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                            <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" disabled={this.state.disableInput} >
                                        <h5 className="bold-text">Operado: </h5>
                                        <RadioGroup
                                            aria-label="operado"
                                            name="operado"
                                            className="material-form__field"
                                            style={{ flexDirection: 'row' }}
                                            value={this.state.diagnostic.operado}
                                            onChange={e => {
                                                this.handlerOperado(e.target.value);
                                            }}
                                        >
                                            <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                            <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                        </RadioGroup>
                                    </FormControl>
                                </Col>
                                <Col xs={6} md={3}>
                                    <FormControl component="fieldset" >
                                        <h5 className="bold-text">Creatinina: </h5>
                                        <TextField
                                            name="creatinina"
                                            label=""
                                            type="number"
                                            className="material-form__field"
                                            style={{ width: 180 }}
                                            disabled={this.state.disableInput}
                                            value={this.state.diagnostic.creatinina}
                                            onChange={(e) => {
                                                this.handlerCreatinina(e.target.value);
                                            }}
                                        />
                                    </FormControl>
                                </Col>
                                <Col xs={6} md={3}>
                                </Col>
                            </Row>

                            {/* <FormControl component="fieldset" disabled={this.state.disableInput}>
                                    <h5 className="bold-text">Clips: </h5>
                                    <RadioGroup
                                        aria-label="clips"
                                        name="clips"
                                        className="material-form__field"
                                        style={{ flexDirection: 'row' }}
                                        value={this.state.diagnostic.clips}
                                        onChange={e => {
                                            this.handlerClips(e.target.value);
                                        }}
                                    >
                                        <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                        <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                    </RadioGroup>
                                </FormControl> */}



                            {/* <FormControl component="fieldset" disabled={this.state.disableInput} >
                                    <h5 className="bold-text">Balas: (Arma de Fuego)</h5>
                                    <RadioGroup
                                        aria-label="balas"
                                        name="balas"
                                        className="material-form__field"
                                        style={{ flexDirection: 'row' }}
                                        value={this.state.diagnostic.balas}
                                        onChange={e => {
                                            this.handlerBalas(e.target.value);
                                        }}
                                    >
                                        <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                        <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                    </RadioGroup>
                                </FormControl> */}

                            {/* <FormControl component="fieldset" disabled={this.state.disableInput}>
                                    <h5 className="bold-text">Grapas: </h5>
                                    <RadioGroup
                                        aria-label="grapas"
                                        name="grapas"
                                        className="material-form__field"
                                        style={{ flexDirection: 'row' }}
                                        value={this.state.diagnostic.grapas}
                                        onChange={e => {
                                            this.handlerGrapas(e.target.value);
                                        }}
                                    >
                                        <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                        <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                    </RadioGroup>
                                </FormControl> */}

                            {/* <FormControl component="fieldset" disabled={this.state.disableInput}>
                                    <h5 className="bold-text">Otros Sintomas: </h5>
                                    <RadioGroup
                                        aria-label="sintomas"
                                        name="sintomas"
                                        className="material-form__field"
                                        style={{ flexDirection: 'row' }}
                                        value={this.state.diagnostic.otros}
                                        onChange={e => {
                                            this.handlerOtros(e.target.value);
                                        }}
                                    >
                                        <FormControlLabel className="radio-btn" value={'x'} control={<Radio style={{ color: '#3f51b5' }} />} label={'Sí'} />
                                        <FormControlLabel className="radio-btn" value={''} control={<Radio style={{ color: '#3f51b5' }} />} label={'No'} />
                                    </RadioGroup>
                                </FormControl> */}


                            <div className="form" >
                                <h4> Observaciones: </h4>
                                <textarea
                                    name='otros-field'
                                    disabled={/* this.state.diagnostic.otros !== "x" || */ this.state.disableInput}
                                    defaultValue={this.state.diagnostic.otrosText}
                                    onChange={(e) => { this.handlerOtrosText(e.target.value.replace(/(\r\n|\n|\r)/gm, " ")) }}
                                >
                                </textarea>

                            </div>
                        </form>

                        <div>
                            <Col md={4}>
                                {
                                    this.state.signaturePatient !== null ? <img style={{ width: 220, height: 75, margin: '1em 0em' }} src={this.state.signaturePatient} /> : null
                                }
                                <br />
                                <Button
                                    className="btn btn-sm"
                                    color="primary"
                                    onClick={() => {
                                        this.setState({ modalSignaturePad: true });
                                    }}
                                    style={{ margin: 10, marginTop: 10 }}
                                >
                                    Firma del Paciente
                                </Button>
                            </Col>

                            <div className="text-center">
                                <Row>
                                    {
                                        /**<Col md={4}>
                                        {
                                            this.state.signaturePatient != null ? <img style={{ width: 220, height: 75 }} src={this.state.signaturePatient} /> : null
                                        }
                                        <br />
                                        <Button
                                            className="btn btn-sm"
                                            color="primary"
                                            onClick={() => {
                                                this.setState({ modalSignaturePad: true });
                                            }}
                                            style={{ margin: 10, marginTop: 10 }}
                                        >
                                            Firma del Paciente
                                        </Button>
                                    </Col> */
                                    }

                                    {
                                        /** <Col md={4}>
                                        <SignatureModalUser
                                            openModalSignature={this.state.openModalSignatureDoctor}
                                            closeModalSignature={() => {
                                                this.setState({ openModalSignatureDoctor: false });
                                            }}
                                            id_usuario={this.props.dataPatient.id_usuario_profesional}
                                        />
                                        <br />
                                        <Button
                                            className="btn btn-sm"
                                            color="primary"
                                            onClick={() => {
                                                this.setState({ openModalSignatureDoctor: true });
                                            }}
                                            style={{ margin: 10, marginTop: 10 }}
                                        >
                                            Firma del Profesional
                                        </Button>
                                    </Col>*/
                                    }
                                    {
                                        /**
                                    <Col md={4}>
                                        <SignatureModalUser
                                            openModalSignature={this.state.openModalSignatureTecnologo}
                                            closeModalSignature={() => {
                                                this.setState({ openModalSignatureTecnologo: false });
                                            }}
                                        />
                                        <br />
                                        <Button
                                            className="btn btn-sm"
                                            color="primary"
                                            onClick={() => {
                                                this.setState({ openModalSignatureTecnologo: true });
                                            }}
                                            style={{ margin: 10, marginTop: 10 }}
                                        >
                                            Firma del Tecnologo
                                        </Button>
                                    </Col> */
                                    }

                                </Row>
                            </div>


                            <br />
                            <br />




                        </div>

                        {this.props.dataPatient.estado === "Abierta" ?
                            <Fragment>
                                {this.props.seeInputDiag !== false ?
                                    <Button
                                        style={{ marginTop: 20 }}
                                        color="primary"
                                        onClick={() => {
                                            this.callPrintEvent();
                                        }}
                                    >
                                        {this.state.exist ? "Generar pdf" : "Guardar"}
                                    </Button>
                                    :
                                    null
                                }

                                {this.state.exist ?
                                    this.state.closed ?
                                        null :
                                        <Button
                                            disabled={this.state.closed}
                                            style={{ marginTop: 20 }}
                                            color="primary"
                                            onClick={() => {
                                                this.setState({ colorAlertModal: 'warning', messageAlerModal: 'Esta seguro que va a guardar y cerrar? Al hacer esto no puede volver a editar', openAlertModal: true });
                                            }}
                                        >
                                            Guardar y Cerrar
                                        </Button>
                                    : null}
                            </Fragment>
                            : <Button
                                style={{ marginTop: 20 }}
                                color="primary"
                                onClick={() => {
                                    this.callPrintEvent();
                                }}
                            >
                                Generar Reporte
                            </Button>}


                        <SearchModalCIE10
                            openModalCIE10={this.state.openModal}
                            closeModalCIE10={() => {
                                this.setState({ openModal: false });
                            }}
                            Callback={(diagnostic) => {
                                var diagnosticNew = diagnostic;
                                this.setState({ loadAddedDiagnostics: true }, () => {
                                    let found = this.state.diagnosticCIE10.find(diag => diag.codigo == diagnostic.codigo)
                                    if (typeof found == "undefined") {
                                        this.state.diagnosticCIE10.push(diagnosticNew);
                                    } else {
                                        alert("Ya se incluyo este diagnostico")
                                    }
                                    this.setState({ openModal: false, loadAddedDiagnostics: false });
                                })
                            }}
                        />

                        {
                            /*
                              <Modal
                            open={this.state.openModal}
                            onClose={() => {
                                this.setState({ openModal: false });
                            }}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ zIndex: 1000 }}
                        >
                            <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                                <div>
                                    <h5 className="bold-text">Diagnostico</h5>
                                </div>
                                <div className="form">
                                    <div style={{ display: 'flex', width: '100%' }}>
                                        <div className="form__form-group" style={{ marginRight: 10 }}>
                                            <span className="form__form-group-label">CIE 10</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="search-cups"
                                                    component="input"
                                                    type="text"
                                                    placeholder="Codigo"
                                                    onChange={(e) => {
                                                        console.log(e.target.value);
                                                        this.setState({ load: true }, () => {
                                                            this.searchCIE("", e.target.value).then((dataDiagnostic) => {
                                                                this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                                                            });
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Nombre</span>
                                            <div className="form__form-group-field">
                                                <input
                                                    name="search-diagnostic"
                                                    type="text"
                                                    placeholder="Diagnostico"
                                                    onChange={(e) => {
                                                        var diagnostic = e.target.value;
                                                        this.setState({ load: true }, () => {
                                                            console.log(diagnostic)
                                                            this.searchCIE(diagnostic, "").then((dataDiagnostic) => {
                                                                this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                                                            });
                                                        });
                                                    }}
                                                >
                                                </input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                    {!this.state.load ?
                                        <DataReactTable
                                            title=""
                                            reactTableData={reactTableFoundDiagnostics}
                                            config={{
                                                withPagination: true,
                                                withSearchEngine: false,
                                                isSortable: false,
                                                watchCustomMenu: false,
                                            }}
                                            ReactTableActions={ReactTableActionsDiagnostic}
                                            Callback={(diagnostic) => {
                                                var diagnosticNew = diagnostic;
                                                this.setState({ loadAddedDiagnostics: true }, () => {
                                                    let found = this.state.diagnosticCIE10.find(diag => diag.codigo == diagnostic.codigo)
                                                    if (typeof found == "undefined") {
                                                        this.state.diagnosticCIE10.push(diagnosticNew);
                                                    } else {
                                                        alert("Ya se incluyo este diagnostico")
                                                    }
                                                    this.setState({ openModal: false, loadAddedDiagnostics: false });
                                                })
                                            }}
                                        /> : <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                            <div className="load__icon-wrap">
                                                <svg className="load__icon">
                                                    <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                                </svg>
                                            </div>
                                        </div>}
                                    {
                                        !this.state.load && this.state.dataDiagnostic.length === 0 ?
                                            <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                                No hay elementos que mostrar
                                            </div>
                                            : null
                                    }
                                </div>
                            </div>
                        </Modal>*/
                        }

                    </CardBody>
                </Card>

                <AlertModal
                    color={this.state.colorAlertModal}
                    title={this.state.messageAlerModal}
                    modal={this.state.openAlertModal}
                    onOk={() => {
                        this.validateOnOkModal();
                    }}
                    toggle={() => {
                        this.setState({ colorAlertModal: 'info', messageAlerModal: '', openAlertModal: false });
                    }}
                />

                <DigitalSignature
                    confirmSign={(value) => {
                        this.setState({
                            signaturePatient: value
                        }, () => {
                            console.log("signaturePatient", this.state.signaturePatient)
                        })
                    }}
                    openModalSignature={this.state.modalSignaturePad}
                    closeModalSignature={() => {
                        this.setState({
                            modalSignaturePad: false
                        })
                    }}
                />
            </Col >
        );
    }
}

export default reduxForm({
    form: 'interview_form', // a unique identifier for this form
})(FormInterview);